// extracted by mini-css-extract-plugin
export var actionButton = "_ig-t";
export var buttonContainer = "_ig-0";
export var buttonContainer2 = "_ig-1";
export var buttonSection = "_ig-2";
export var details = "_ig-3";
export var dropdownItem = "_ig-5";
export var dropdownItemsContainer = "_ig-4";
export var fileInput = "_ig-r";
export var headerButton = "_ig-6";
export var icon = "_ig-7";
export var input = "_ig-8";
export var macroListItem = "_ig-9";
export var mainContent = "_ig-a";
export var microText = "_ig-b";
export var modal = "_ig-w";
export var optionsButton = "_ig-c";
export var paperclip = "_ig-s";
export var pillContent = "_ig-d";
export var preview = "_ig-e";
export var preview2 = "_ig-f";
export var quillEditor = "_ig-q";
export var selectedMacro = "_ig-g";
export var sidebar = "_ig-h";
export var sidebarHeader = "_ig-j";
export var sidebarList = "_ig-i";
export var sidebarListItem = "_ig-k";
export var sidebarSearch = "_ig-l";
export var snoozeDurationWrapper = "_ig-v";
export var statusPillContainer = "_ig-m";
export var tagsContainer = "_ig-n";
export var unselectedMacro = "_ig-o";
export var variable = "_ig-u";
export var wrapper = "_ig-p";